import { Box } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-premium'
import { renderTextOnly, userAvatar } from 'components/DataGrid/operators/minimalistFunctions'
import { FC } from 'react'
import { DensityStyleTypes } from 'types'

interface RenderQueueCellProps {
  params: GridRenderCellParams
  isTextOnly: boolean
  densityStyles: DensityStyleTypes
}
const QueueCell: FC<RenderQueueCellProps> = ({ params, isTextOnly, densityStyles }) => {
  const queue = params?.row?.queue

  // --- TEXT ONLY RENDERING ---
  if (isTextOnly) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'center',
          height: '100%',
          padding: densityStyles.padding,
        }}
      >
        {renderTextOnly(params, queue, densityStyles)}
      </Box>
    )
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        height: '100%',
        padding: densityStyles.padding,
      }}
    >
      {userAvatar(queue, densityStyles)}
    </Box>
  )
}

export default QueueCell
